import { render } from "./App.vue?vue&type=template&id=682946b0&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=682946b0&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=682946b0&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682946b0"]])

export default __exports__